import script from "./factory.vue?vue&type=script&lang=ts&setup=true"
export * from "./factory.vue?vue&type=script&lang=ts&setup=true"

import "./factory.vue?vue&type=style&index=0&id=47006aba&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47006aba"]])

export default __exports__